import axios from "axios";
import utils from "./utils";

const dataUrl = 'https://hostess.lega6.com/php/index.php';

const fetchWithRetry = async (url, options = {}) => {
    try {
        const response = await fetch(url, {
            ...options,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.json();
    } catch (error) {
        console.warn('Original request failed, trying with proxy:', error);

        // Using a proxy service as a fallback
        const proxyUrl = `https://your-proxy-service.com/${url}`;
        const proxyResponse = await fetch(proxyUrl, options);
        return proxyResponse.json();
    }
};

function sendData(data, errorFunc = () => {}, func = null) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        withCredentials: true,
    };

    if (utils.isLog()) console.log('before data sent act:', data.type.act);

    return axios.post(dataUrl, data, config)
        .then(response => {
            if (utils.isLog()) console.log('res:', response.data);
            if (response.data && response.data.debug && response.data.debug.statusCode) {
                switch (response.data.debug.statusCode) {
                    case 705:
                        if (func !== 'sendBack') {
                            if (utils.isLog()) console.log('NOT SEND BACK');
                            if (typeof func === 'function') func(response.data);
                        }
                        else return response.data;
                        break;
                    case 605:
                        break;
                    case 415:
                        if (func !== 'sendBack') {
                            if (utils.isLog()) console.log('NOT SEND BACK');
                            if (typeof func === 'function') func(response.data);
                        }
                        else return response.data;
                        break;
                    case 313:
                        if (typeof errorFunc === 'function') errorFunc();
                        break;
                    case 100:
                        if (func !== 'sendBack') {
                            if (utils.isLog()) console.log('NOT SEND BACK');
                            if (typeof func === 'function') func(response.data);
                        } else {
                            if (utils.isLog()) console.log('SEND BACK');
                            return response.data;
                        }
                        break;
                    default:
                        if (utils.isLog()) console.warn('Unhandled status code:', response.data.debug.statusCode);
                }
            } else {
                if (utils.isLog()) console.warn('Unexpected response structure:', response);
                if (typeof errorFunc === 'function') errorFunc();
            }
        })
        .catch(async error => {
            if (utils.isLog()) console.error('Error:', error);

            // Retry with fetch as a fallback mechanism
            try {
                const fallbackResponse = await fetchWithRetry(dataUrl, {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });
                return fallbackResponse;
            } catch (retryError) {
                console.error('Retry with fetch failed:', retryError);
                if (typeof errorFunc === 'function') errorFunc();
                return Promise.reject(retryError);
            }
        });
}

export default {
    sendData,
    fetchWithRetry
};
